import { render } from "./prescriptions_demande_view_tab.vue?vue&type=template&id=7047efec"
import script from "./prescriptions_demande_view_tab.vue?vue&type=script&lang=js"
export * from "./prescriptions_demande_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__